
import React, { forwardRef, useRef } from 'react'
import { AgGridReact } from 'ag-grid-react';
import '../../../assets/styles/ag-grid-style.css'
import { defaultColDef, defaultColDefWithoutFilter, defaultColDefWithScroll, defaultColDefWithScrollNoFilterText } from '../../../assets/UtilMethods'
import { useStateContext } from "../../../contexts/ContextProvider"; // Optional theme CSS
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.min.css';
export const useBlsGridTable = gridData => {

    const dataRef = useRef(gridData)

    return dataRef.current

}

const BlsGridTable = forwardRef(({
                                     columnDefs = [],
                                     headerHeight = 30,
                                     rowHeight = 25,
                                     rowData = [],
                                     onColumnResized = true,
                                     enableCellChangeFlash = false,
                                     enableCellTextSelection = true,
                                     enableCellExpressions = true,
                                     enableSorting = true,
                                     enableFilter = true,
                                     enableGroupEdit = true,
                                     rowClassRules,
                                     onCellClicked,
                                     pagination = true,
                                     paginationPageSize = 30,
                                     onSelectionChanged,
                                     onRowClicked,
                                     onRowDoubleClicked,
                                     overlayNoRowsTemplate = '<span></span>', //<span class="ag-overlay-loading-center">Veri Bulunamadı</span>,
                                     overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Veriler yukleniyor... </span>',
                                     rowSelection = "single",
                                     frameworkComponents,
                                     height = "100%",
                                     width = "100%",
                                     filterText = true,
                                     defaultColDefFromProps = {},
                                     containerStyle = {},
                                     tooltipShowDelay,
                                     tooltipHideDelay,
                                     suppressRowClickSelection,
                                     isRowSelectable, onFirstDataRendered,
                                     onCellValueChanged ,
                                     children,
                                     scroll = false,
                                     headerTooltip = false,
                                     statusBar,
                                     suppressPaginationPanel
                                 }, ref) => {
        const { currentMode } = useStateContext();

        return (
            <div className={currentMode === "Dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"} style={{height: `calc(${height} - 30px)`, width: width, marginTop: "5px", ...containerStyle}}>
                <AgGridReact
                    ref={ref}
                    columnDefs={headerTooltip ? columnDefs.map((col) => ({headerTooltip: col?.headerName, ...col})) : columnDefs}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    rowData={rowData}
                    onColumnResized={onColumnResized}
                    enableCellChangeFlash={enableCellChangeFlash}
                    enableCellTextSelection={enableCellTextSelection}
                    enableCellExpressions={enableCellExpressions}
                    enableSorting={enableSorting}
                    enableFilter={enableFilter}
                    enableGroupEdit={enableGroupEdit}
                    rowClassRules={rowClassRules}
                    defaultColDef={
                        filterText && !scroll ? {...defaultColDef, ...defaultColDefFromProps} :
                            filterText && scroll ? {...defaultColDefWithScroll, ...defaultColDefFromProps} :
                                !filterText && scroll ? {...defaultColDefWithScrollNoFilterText, ...defaultColDefFromProps}
                                    : {...defaultColDefWithoutFilter, ...defaultColDefFromProps}}
                    onCellClicked={onCellClicked}
                    onSelectionChanged={onSelectionChanged}
                    onRowClicked={onRowClicked}
                    overlayNoRowsTemplate={overlayNoRowsTemplate}
                    overlayLoadingTemplate={overlayLoadingTemplate}
                    onRowDoubleClicked={onRowDoubleClicked}
                    rowSelection={rowSelection}
                    pagination={pagination}
                    paginationPageSize={paginationPageSize}
                    frameworkComponents={frameworkComponents}
                    tooltipShowDelay={tooltipShowDelay}
                    tooltipHideDelay={tooltipHideDelay}
                    suppressRowClickSelection={suppressRowClickSelection}
                    isRowSelectable={isRowSelectable}
                    onFirstDataRendered={onFirstDataRendered}
                    suppressRowTransform={true}
                    onCellValueChanged={onCellValueChanged}
                    statusBar={statusBar}
                    suppressPaginationPanel={suppressPaginationPanel}
                >
                    {children}
                </AgGridReact>
            </div>
        )
    }
);

export default BlsGridTable